/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BlogCategory,
  BlogCategoryCreate,
  BlogCategoryUpdate,
  HTTPValidationError,
} from '../models/index';
import {
    BlogCategoryFromJSON,
    BlogCategoryToJSON,
    BlogCategoryCreateFromJSON,
    BlogCategoryCreateToJSON,
    BlogCategoryUpdateFromJSON,
    BlogCategoryUpdateToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface CreateBlogCategoryApiV1BlogCategoriesPostRequest {
    blogCategoryCreate: BlogCategoryCreate;
}

export interface CreateBlogCategoryApiV1BlogCategoriesPost0Request {
    blogCategoryCreate: BlogCategoryCreate;
}

export interface DeleteBlogCategoryApiV1BlogCategoriesIdDeleteRequest {
    id: number;
}

export interface ReadBlogCategoriesApiV1BlogCategoriesGetRequest {
    skip?: number;
    limit?: number;
}

export interface ReadBlogCategoriesApiV1BlogCategoriesGet0Request {
    skip?: number;
    limit?: number;
}

export interface ReadBlogCategoryByIdApiV1BlogCategoriesIdGetRequest {
    id: number;
}

export interface UpdateBlogCategoryApiV1BlogCategoriesIdPutRequest {
    id: number;
    blogCategoryUpdate: BlogCategoryUpdate;
}

/**
 * 
 */
export class BlogCategoriesApi extends runtime.BaseAPI {

    /**
     * Create new blog category.
     * Create Blog Category
     */
    async createBlogCategoryApiV1BlogCategoriesPostRaw(requestParameters: CreateBlogCategoryApiV1BlogCategoriesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BlogCategory>> {
        if (requestParameters['blogCategoryCreate'] == null) {
            throw new runtime.RequiredError(
                'blogCategoryCreate',
                'Required parameter "blogCategoryCreate" was null or undefined when calling createBlogCategoryApiV1BlogCategoriesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/blog-categories/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BlogCategoryCreateToJSON(requestParameters['blogCategoryCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlogCategoryFromJSON(jsonValue));
    }

    /**
     * Create new blog category.
     * Create Blog Category
     */
    async createBlogCategoryApiV1BlogCategoriesPost(requestParameters: CreateBlogCategoryApiV1BlogCategoriesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BlogCategory> {
        const response = await this.createBlogCategoryApiV1BlogCategoriesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new blog category.
     * Create Blog Category
     */
    async createBlogCategoryApiV1BlogCategoriesPost_1Raw(requestParameters: CreateBlogCategoryApiV1BlogCategoriesPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BlogCategory>> {
        if (requestParameters['blogCategoryCreate'] == null) {
            throw new runtime.RequiredError(
                'blogCategoryCreate',
                'Required parameter "blogCategoryCreate" was null or undefined when calling createBlogCategoryApiV1BlogCategoriesPost_1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/blog-categories`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BlogCategoryCreateToJSON(requestParameters['blogCategoryCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlogCategoryFromJSON(jsonValue));
    }

    /**
     * Create new blog category.
     * Create Blog Category
     */
    async createBlogCategoryApiV1BlogCategoriesPost_1(requestParameters: CreateBlogCategoryApiV1BlogCategoriesPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BlogCategory> {
        const response = await this.createBlogCategoryApiV1BlogCategoriesPost_1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a blog category.
     * Delete Blog Category
     */
    async deleteBlogCategoryApiV1BlogCategoriesIdDeleteRaw(requestParameters: DeleteBlogCategoryApiV1BlogCategoriesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BlogCategory>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteBlogCategoryApiV1BlogCategoriesIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/blog-categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlogCategoryFromJSON(jsonValue));
    }

    /**
     * Delete a blog category.
     * Delete Blog Category
     */
    async deleteBlogCategoryApiV1BlogCategoriesIdDelete(requestParameters: DeleteBlogCategoryApiV1BlogCategoriesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BlogCategory> {
        const response = await this.deleteBlogCategoryApiV1BlogCategoriesIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve blog categories.
     * Read Blog Categories
     */
    async readBlogCategoriesApiV1BlogCategoriesGetRaw(requestParameters: ReadBlogCategoriesApiV1BlogCategoriesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BlogCategory>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/blog-categories/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BlogCategoryFromJSON));
    }

    /**
     * Retrieve blog categories.
     * Read Blog Categories
     */
    async readBlogCategoriesApiV1BlogCategoriesGet(requestParameters: ReadBlogCategoriesApiV1BlogCategoriesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BlogCategory>> {
        const response = await this.readBlogCategoriesApiV1BlogCategoriesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve blog categories.
     * Read Blog Categories
     */
    async readBlogCategoriesApiV1BlogCategoriesGet_2Raw(requestParameters: ReadBlogCategoriesApiV1BlogCategoriesGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BlogCategory>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/blog-categories`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BlogCategoryFromJSON));
    }

    /**
     * Retrieve blog categories.
     * Read Blog Categories
     */
    async readBlogCategoriesApiV1BlogCategoriesGet_2(requestParameters: ReadBlogCategoriesApiV1BlogCategoriesGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BlogCategory>> {
        const response = await this.readBlogCategoriesApiV1BlogCategoriesGet_2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific blog category by id.
     * Read Blog Category By Id
     */
    async readBlogCategoryByIdApiV1BlogCategoriesIdGetRaw(requestParameters: ReadBlogCategoryByIdApiV1BlogCategoriesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BlogCategory>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readBlogCategoryByIdApiV1BlogCategoriesIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/blog-categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlogCategoryFromJSON(jsonValue));
    }

    /**
     * Get a specific blog category by id.
     * Read Blog Category By Id
     */
    async readBlogCategoryByIdApiV1BlogCategoriesIdGet(requestParameters: ReadBlogCategoryByIdApiV1BlogCategoriesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BlogCategory> {
        const response = await this.readBlogCategoryByIdApiV1BlogCategoriesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a blog category.
     * Update Blog Category
     */
    async updateBlogCategoryApiV1BlogCategoriesIdPutRaw(requestParameters: UpdateBlogCategoryApiV1BlogCategoriesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BlogCategory>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateBlogCategoryApiV1BlogCategoriesIdPut().'
            );
        }

        if (requestParameters['blogCategoryUpdate'] == null) {
            throw new runtime.RequiredError(
                'blogCategoryUpdate',
                'Required parameter "blogCategoryUpdate" was null or undefined when calling updateBlogCategoryApiV1BlogCategoriesIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2PasswordBearer", []);
        }

        const response = await this.request({
            path: `/api/v1/blog-categories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BlogCategoryUpdateToJSON(requestParameters['blogCategoryUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BlogCategoryFromJSON(jsonValue));
    }

    /**
     * Update a blog category.
     * Update Blog Category
     */
    async updateBlogCategoryApiV1BlogCategoriesIdPut(requestParameters: UpdateBlogCategoryApiV1BlogCategoriesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BlogCategory> {
        const response = await this.updateBlogCategoryApiV1BlogCategoriesIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
